import { ListItemButton } from "@mui/material";
import { Link } from "react-router-dom";
import colorConfigs from "./colourConfigs";
import { useEffect, useState } from "react";

const SidebarItem = ({ item }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (window.location.pathname === item.path) {
      setIsActive(true);
    }
    return () => {
      setIsActive(false);
    };
    //eslint-disable-next-line
  }, [window.location.pathname]);

  return item.sidebarProps && item.path ? (
    <ListItemButton
      component={Link}
      to={item.path}
      sx={{
        "&: hover": {
          backgroundColor: colorConfigs.sidebar.hoverBg,
        },
        backgroundColor: isActive ? colorConfigs.sidebar.activeBg : "unset",
      }}
    >
      {item.sidebarProps.displayText}
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
